import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  useTheme,
} from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../../commonUI/cssClasses';
import { LatestScanColors } from '../../layers/BlockOutlineLayer';
import { ColorBox } from './components/ColorBox';
interface LegendRow {
  title: string;
  color: LatestScanColors;
}

const RanchSummaryLegend: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const legendRows: LegendRow[] = useMemo(
    () => [
      {
        title: `< 1 ${t('Week')}`,
        color: LatestScanColors.oneWeek,
      },
      {
        title: `< 30 ${t('Days')}`,
        color: LatestScanColors.thirtyDays,
      },
      {
        title: `< 3 ${t('Months')}`,
        color: LatestScanColors.threeMonths,
      },
      {
        title: `< 6 ${t('Months')}`,
        color: LatestScanColors.sixMonths,
      },
      {
        title: `< 1 ${t('Year')}`,
        color: LatestScanColors.oneYear,
      },
      {
        title: `> 1 ${t('Year')}`,
        color: LatestScanColors.greaterThanOneYear,
      },
      {
        title: t('No Scans'),
        color: LatestScanColors.defaultColor,
      },
    ],
    [t]
  );

  return (
    <Box
      sx={{
        width: '100%',
        ...flexCenter,
        flexDirection: 'column',
        p: '0.3rem',
      }}
    >
      <Typography
        sx={{
          fontSize: '1rem',
          color: theme.colors.common.white,
        }}
        gutterBottom
      >
        {t('Latest Scan')}
      </Typography>
      <List dense sx={{ p: 0 }}>
        {legendRows.map((row, idx) => (
          <ListItem key={idx} sx={{ p: 0 }}>
            <ListItemIcon sx={{ minWidth: '2rem' }}>
              <ColorBox color={row.color} />
            </ListItemIcon>
            <Typography
              sx={{
                fontSize: '1rem',
                color: theme.colors.common.white,
              }}
            >
              {row.title}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default RanchSummaryLegend;
